import { AliceAndJarek, AngelikaAndDaniel, AniaAndAdam, AniaAndBen, FoodtruckWedding, MagdaAndSzymon, DagaAndAsh, AniaAndSzymon, JoannaAndRick, EwaAndAdam, IgaAndPawel, MartaAndTaras, KrisAndLuk } from './utils/index'

const weddings = [
    KrisAndLuk,
    MartaAndTaras,
    EwaAndAdam,
    IgaAndPawel,
    JoannaAndRick,
    AniaAndSzymon,
    DagaAndAsh,
    AliceAndJarek,
    AniaAndAdam,
    AniaAndBen,
    FoodtruckWedding,
    AngelikaAndDaniel,
    MagdaAndSzymon
]

export default weddings